<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TtpYvI/image/9780369711182.jpg?1739570927004" alt="This image is the cover for the book Blues Singer to Redeem Him"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blues Singer to Redeem Him
      </h1>
      <p class="bookDescription body article font2">
        <b>Nights at the speakeasy…</b><br/><br/><i>Spark a dangerous romance</i><br/><br/> Evelyn Laroque’s performances at Lorenzo De Luca’s Kansas City blues club draw even bigger crowds than his bootleg whiskey. And every time he hears her voice, Lorenzo falls a little harder for the achingly beautiful blues singer. When Evelyn becomes a target for the KKK, Lorenzo faces an impossible choice. Will this son of a gangster turn to the mob if it’s the only way to protect the woman he loves? <br/><br/><b>From Harlequin Historical: <i>Your romantic escape to the past.</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elle Jackson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8662330